import {
  IChoiceGroupOptionStyleProps,
  IChoiceGroupOptionStyles
} from '@fluentui/react/lib/ChoiceGroup';
import { ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors } from '../teams-colors';
import { teamsButtonBorderRadius } from './constants';

export function getChoiceGroupOptionStyles(themeName: string, _theme: ITheme) {
  return (
    props: IChoiceGroupOptionStyleProps
  ): Partial<IChoiceGroupOptionStyles> => {
    const { disabled, checked, theme } = props;
    const { palette } = theme;

    let CHOICEGROUPOPTION_BORDER_COLOR = palette.neutralTertiary;
    let CHECKBOX_LABEL_COLOR = palette.neutralTertiary;

    if (themeName === 'contrast') {
      CHOICEGROUPOPTION_BORDER_COLOR = ContrastColors.appGreenContrast;
      CHECKBOX_LABEL_COLOR = ContrastColors.appGreenContrast;
    }

    const styles = {
      root: {
        minHeight: 25,
        marginTop: 0,
        selectors: {
          '.ms-Fabric--isFocusVisible &': {
            selectors: {
              '.is-inFocus': {
                selectors: {
                  ':after': {
                    borderColor: palette.black,
                    right: '-5px',
                    borderRadius: teamsButtonBorderRadius
                  }
                }
              }
            }
          }
        }
      },
      choiceFieldWrapper: [
        {
          background: 'transparent'
        },
        disabled && {
          color: CHECKBOX_LABEL_COLOR
        },
        !disabled &&
          checked && {
            color: palette.black
          },

        !disabled &&
          !checked && {
            color: palette.neutralDark
          }
      ],
      field: [
        {
          selectors: {
            '.ms-ChoiceField-field': {
              color: 'inherit'
            },
            '.ms-ChoiceFieldLabel': {
              color: 'inherit'
            },
            ':hover': [
              !disabled && {
                selectors: {
                  ':before': {
                    borderColor: palette.black
                  }
                }
              }
            ],
            ':before': {
              height: 12,
              width: 12,
              top: 5,
              left: 5
            },
            ':after': {
              height: 12,
              width: 12,
              top: 5,
              left: 5,
              borderWidth: 6
            }
          }
        },
        !disabled &&
          !checked && {
            selectors: {
              ':before': {
                borderColor: palette.neutralDark
              }
            }
          },
        !disabled &&
          checked && {
            color: palette.black,
            selectors: {
              ':before': {
                borderColor: palette.themePrimary
              },
              ':after': {
                borderColor: palette.themePrimary
              }
            }
          },
        disabled &&
          !checked && {
            selectors: {
              ':before': {
                borderColor: CHOICEGROUPOPTION_BORDER_COLOR,
                background: 'transparent'
              },
              ':after': {
                borderColor: CHOICEGROUPOPTION_BORDER_COLOR
              }
            }
          },
        disabled &&
          checked && {
            selectors: {
              ':before': {
                borderColor: CHOICEGROUPOPTION_BORDER_COLOR,
                background: 'transparent'
              },
              ':after': {
                borderColor: CHOICEGROUPOPTION_BORDER_COLOR
              }
            }
          }
      ]
    } as Partial<IChoiceGroupOptionStyles>;

    return styles;
  };
}
